import React, { useEffect, useState } from 'react';
import { NAV_LINKS, TICKER_ITEMS } from './salesData';

/**
 * Franja superior con movimiento continuo + navegación sticky mínima.
 * Sin CTA en la barra: en mobile cada píxel de altura va al hero, y el precio
 * de esta carta de ventas aparece recién en la sección de oferta.
 */
export function NavBar() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  const ticker = [...TICKER_ITEMS, ...TICKER_ITEMS];
  return <>
      <div className="overflow-hidden border-b border-gold/25 bg-gold-pale" aria-hidden data-id="element-165" data-mp="25ufnfrnea9ka">
        <div className="animate-ticker flex w-max items-center py-1 sm:py-1.5" data-id="element-166" data-mp="3lbfq9wtq0fg3">
          {ticker.map((item, index) => <span key={`${item}-${index}`} className="flex shrink-0 items-center whitespace-nowrap font-sans text-[0.58rem] font-bold uppercase tracking-[0.16em] text-charcoal/75 sm:text-[0.62rem]" data-id="element-167" data-mp="3havxf5g6jxzr" data-mpi={index}>
              {item}
              <span className="mx-4 text-gold-deep sm:mx-6" aria-hidden data-id="element-168" data-mp="1kwxji0w4h9h9">
                •
              </span>
            </span>)}
        </div>
      </div>

      <header className={`sticky top-0 z-30 border-b transition-colors duration-200 ease-out ${scrolled ? 'border-warm bg-ivory/95 backdrop-blur' : 'border-transparent bg-ivory'}`} data-id="element-169" data-mp="1pviaratecitk">
        <div className="mx-auto flex w-full max-w-6xl items-center justify-between gap-4 px-4 py-1.5 sm:px-8 sm:py-3" data-id="element-170" data-mp="x59vpru5qej7">
          <a href="#top" className="flex items-baseline gap-2 leading-none" data-id="element-171" data-mp="16x60flqr12we">
            <span className="font-display text-[0.9rem] tracking-tight text-charcoal sm:text-lg" data-id="element-172" data-mp="16z8uqhyxpi6x">
              SISTEMA <span className="text-gold-deep" data-id="element-173" data-mp="9fxq11y1goln">IA</span>
            </span>
            <span className="font-sans text-[0.47rem] font-semibold uppercase tracking-[0.16em] text-charcoal/50 sm:text-[0.56rem]" data-id="element-174" data-mp="ef20rx0m2ue3">
              Para nutricionistas
            </span>
          </a>

          <nav aria-label="Secciones" className="hidden items-center gap-7 lg:flex" data-id="element-175" data-mp="1csfo24jxd54p">
            {NAV_LINKS.map(link => <a key={link.href} href={link.href} className="font-sans text-[0.72rem] font-semibold uppercase tracking-[0.1em] text-charcoal/60 transition-colors duration-200 ease-out hover:text-gold-deep" data-id="element-176" data-mp="1mihc4wca2njm">
                {link.label}
              </a>)}
          </nav>
        </div>
      </header>
    </>;
}